import React from "react";
import Styles from "./CompanyDetails.module.css";

const CompanyMainDetails = ({ company }) => {
  return (
    <>
      <div className={`display_flex_column_gap_8 ${Styles.detailsContainer}`}>
        <div className={Styles.sectionHeader}>Company Details</div>
        <div className={`${Styles.detailRow}`}>
          <div className={`display_flex_column_gap_8 ${Styles.detailItem}`}>
            <div>Company User Name</div>
            <div>{company?.companyAdminUserName || "-"}</div>
          </div>
          <div className={`display_flex_column_gap_8 ${Styles.detailItem}`}>
            <div>Registeration Date</div>
            <div>{company?.registeredAt || "-"}</div>
          </div>
          <div className={`display_flex_column_gap_8 ${Styles.detailItem}`}>
            <div>Member Id</div>
            <div>{company?.memberId || "-"}</div>
          </div>
          <div className={`display_flex_column_gap_8 ${Styles.detailItem}`}>
            <div>Category</div>
            <div>{company?.categoryName || "-"}</div>
          </div>
          <div className={`display_flex_column_gap_8 ${Styles.detailItem}`}>
            <div>GST Number</div>
            <div>{company?.gst || "-"}</div>
          </div>
          <div className={`display_flex_column_gap_8 ${Styles.detailItem}`}>
            <div>PAN Numbar</div>
            <div>{company?.pan || "-"}</div>
          </div>
          <div className={`display_flex_column_gap_8 ${Styles.detailItem}`}>
            <div>TAN Number</div>
            <div>{company?.tan || "-"}</div>
          </div>
          <div className={`display_flex_column_gap_8 ${Styles.detailItem}`}>
            <div>Trading Lisence No.</div>
            <div>{company?.tradingLicenseNumber || "-"}</div>
          </div>
          <div className={`display_flex_column_gap_8 ${Styles.detailItem}`}>
            <div>Description</div>
            <div>{company?.description || "-"}</div>
          </div>
        </div>
      </div>
      <div className={`display_flex_column_gap_8 ${Styles.detailsContainer}`}>
        <div className={Styles.sectionHeader}>Bank Details</div>
        <div className={`${Styles.detailRow}`}>
          <div className={`display_flex_column_gap_8 ${Styles.detailItem}`}>
            <div>Bank Name</div>
            <div>{company?.companyBankAccount?.bankName}</div>
          </div>
          <div className={`display_flex_column_gap_8 ${Styles.detailItem}`}>
            <div>Bank Account Number</div>
            <div>{company?.companyBankAccount?.accountNumber}</div>
          </div>
          <div className={`display_flex_column_gap_8 ${Styles.detailItem}`}>
            <div>Bank Address</div>
            <div>{company?.companyBankAccount?.branchAddress}</div>
          </div>
          <div className={`display_flex_column_gap_8 ${Styles.detailItem}`}>
            <div>IFSC Code</div>
            <div>{company?.companyBankAccount?.ifscCode}</div>
          </div>
        </div>
      </div>
      <div className={`display_flex_column_gap_8 ${Styles.detailsContainer}`}>
        <div className={Styles.sectionHeader}>Office Address</div>
        <div className={`${Styles.detailRow}`}>
          <div className={`display_flex_column_gap_8 ${Styles.detailItem}`}>
            <div>Address</div>
            <div>{company?.companyOfficeAddress?.address}</div>
          </div>
          <div className={`display_flex_column_gap_8 ${Styles.detailItem}`}>
            <div>Pincode</div>
            <div>{company?.companyOfficeAddress?.pinCode}</div>
          </div>
          <div className={`display_flex_column_gap_8 ${Styles.detailItem}`}>
            <div>City</div>
            <div>{company?.companyOfficeAddress?.cityName}</div>
          </div>
          <div className={`display_flex_column_gap_8 ${Styles.detailItem}`}>
            <div>State</div>
            <div>{company?.companyOfficeAddress?.stateUtName}</div>
          </div>
          <div className={`display_flex_column_gap_8 ${Styles.detailItem}`}>
            <div>Contact</div>
            <div>{company?.companyOfficeAddress?.contactPersonName}</div>
          </div>
          <div className={`display_flex_column_gap_8 ${Styles.detailItem}`}>
            <div>Email</div>
            <div>{company?.companyOfficeAddress?.email}</div>
          </div>
          <div className={`display_flex_column_gap_8 ${Styles.detailItem}`}>
            <div>Mobile</div>
            <div>{company?.companyOfficeAddress?.mobileNumber}</div>
          </div>
          <div className={`display_flex_column_gap_8 ${Styles.detailItem}`}>
            <div>Alt. Mobile</div>
            <div>{company?.companyOfficeAddress?.alternateMobileNumber}</div>
          </div>
        </div>
      </div>
      <div className={`display_flex_column_gap_8 ${Styles.detailsContainer}`}>
        <div className={Styles.sectionHeader}>Correspondence Address</div>
        <div className={`${Styles.detailRow}`}>
          <div className={`display_flex_column_gap_8 ${Styles.detailItem}`}>
            <div>Address</div>
            <div>{company?.companyCorrespondenceAddress?.address}</div>
          </div>
          <div className={`display_flex_column_gap_8 ${Styles.detailItem}`}>
            <div>Pincode</div>
            <div>{company?.companyCorrespondenceAddress?.pinCode}</div>
          </div>
          <div className={`display_flex_column_gap_8 ${Styles.detailItem}`}>
            <div>City</div>
            <div>{company?.companyCorrespondenceAddress?.cityName}</div>
          </div>
          <div className={`display_flex_column_gap_8 ${Styles.detailItem}`}>
            <div>State</div>
            <div>{company?.companyCorrespondenceAddress?.stateUtName}</div>
          </div>
          <div className={`display_flex_column_gap_8 ${Styles.detailItem}`}>
            <div>Contact</div>
            <div>
              {company?.companyCorrespondenceAddress?.contactPersonName}
            </div>
          </div>
          <div className={`display_flex_column_gap_8 ${Styles.detailItem}`}>
            <div>Email</div>
            <div>{company?.companyCorrespondenceAddress?.email}</div>
          </div>
          <div className={`display_flex_column_gap_8 ${Styles.detailItem}`}>
            <div>Mobile</div>
            <div>{company?.companyCorrespondenceAddress?.mobileNumber}</div>
          </div>
          <div className={`display_flex_column_gap_8 ${Styles.detailItem}`}>
            <div>Alt. Mobile</div>
            <div>
              {company?.companyCorrespondenceAddress?.alternateMobileNumber}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CompanyMainDetails;
